import { useCallback, useEffect } from 'react'

import Dialog from '@mui/material/Dialog'

import { useDialogState } from '@/hooks/useDialogState'
import SidebarLayout from '@/layouts/diagnostic/Sidebar'
import Documents from '@/pages/diagnostic/containers/Documents'

type SidebarProps = {
  consultationId?: string
  menuItems: Array<{
    id: string
    icon: any
    label: string
    isMenuDiagnostic?: boolean
    isNested?: boolean
  }>
  selectedMenuItem: string
  onSelect: (menuItemId: string) => void
  documentsDialogOpen?: boolean
  onDocumentsDialogChange?: (open: boolean) => void
}

export function Sidebar({ consultationId, menuItems, selectedMenuItem, onSelect, documentsDialogOpen, onDocumentsDialogChange }: SidebarProps) {
  const { dialogState, setDialogState, closeDialog } = useDialogState<'documents'>('none')

  // Sync external open state into internal dialog state
  useEffect(() => {
    if (documentsDialogOpen) {
      setDialogState('documents')
    }
  }, [documentsDialogOpen, setDialogState])

  const handleCloseDialog = useCallback(() => {
    closeDialog()
    onDocumentsDialogChange?.(false)
  }, [closeDialog, onDocumentsDialogChange])

  const handleSelectMenuItem = (id: string) => {
    switch (id) {
      case 'dmp':
        window.open(`/efficience-web?consultationId=${consultationId}`, '_blank')
        return
      case 'mss':
        window.open(`/efficience-web?consultationId=${consultationId}&mode=mss`, '_blank')
        return
      case 'documents':
        setDialogState('documents')
        onDocumentsDialogChange?.(true)
        return
      default:
        onSelect(id)
    }
  }

  return (
    <>
      <SidebarLayout menuItems={menuItems} onSelect={handleSelectMenuItem} selectedMenuItem={selectedMenuItem} />
      <Dialog fullWidth maxWidth="md" open={dialogState === 'documents'} onClose={handleCloseDialog}>
        <Documents consultationId={consultationId} />
      </Dialog>
    </>
  )
}
